<template>
  <div class="yoga-cancel-feedback container">
    <p>עצוב לנו שאת\ה עוזב אותנו. עזור לנו להשתפר, ספר\י לנו
      , נודה לך אם תוכל לפרט את סיבת העזיבה כדי שנוכל לשפר את השרות שלנו:</p>
    <checkbox-container :options="options" config="cancelConfig"
     :single="true"></checkbox-container>
    <p><label for="message">אחר</label></p>
    <div class="is-clearfix">
      <textarea v-model="message"></textarea>
      <router-link :to="{name: 'cancel'}" class="yoga-btn-beige">
        דלג והמשך
      </router-link>

      <button class="yoga-btn-beige is-pulled-left"
      @click="sendFeedback">
        שלח
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";

import CheckboxContainer from "@/components/account/CheckboxContainer.vue";

export default {
  name: `Feedback`,
  components: {
    CheckboxContainer
  },

  data() {
    return {
      message: ``
    };
  },

  computed: {
    options() {
      return this.$store.state.user.cancelConfig;
    },
    optionSelected() {
      const options = this.$store.state.user.cancelConfig.filter((opt) => {
        if (opt.selected) {
          return true;
        }
        return false;
      });
      if (options.length === 0) { return ``; }
      return options[0].label;
    }
  },

  methods: {
    sendFeedback() {
      // post user feedback - message + option selected
      axios
        .post(
          `${process.env.VUE_APP_API_POST_SENDFEEDBACK}`,
          qs.stringify({
            message: this.message,
            option: this.optionSelected,
            username: this.$store.state.user.email
          }),
        )
        .then((res) => {
          if (res.data.response === `saved`) {
            this.$router.push({ name: `cancel` });
          }
        })
        .catch((e) => {
          this.$store.commit(`addError`, e);
        });
    }
  }
};
</script>

<style lang="scss">
$purple: #656b85;

.yoga-cancel-feedback {
  padding: 50px 0;
  color: $purple;

  .checkbox {
    display: block;
  }

  .is-clearfix {
    max-width: 400px;
  }

  textarea {
    background-color: transparent;
    width: 100%;
    min-height: 200px;
  }
}
</style>
